"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelEditState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var observable_map_1 = require("../util/observable.map");
var FormModelEditState = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelEditState, _super);
    function FormModelEditState(form) {
        var _this = _super.call(this, form) || this;
        _this.fields = new observable_map_1.ObservableIMap();
        _this.properties = new observable_map_1.ObservableIMap();
        _this.internalState = form.state;
        _this.setDisplayName(form.displayName);
        _this.setDescription(form.description);
        return _this;
    }
    Object.defineProperty(FormModelEditState.prototype, "id", {
        get: function () { return this.internalState.id; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "revision", {
        get: function () { return this.internalState.revision; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "version", {
        get: function () { return this.internalState.version; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "rootFormId", {
        get: function () { return this.internalState.rootFormId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "name", {
        get: function () { return this.internalState.name; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "updatedAt", {
        get: function () { return this.internalState.updatedAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "createdAt", {
        get: function () { return this.internalState.createdAt; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "updatedBy", {
        get: function () { return this.internalState.updatedBy; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "v", {
        get: function () { return this.internalState.v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "metadata", {
        get: function () { return this.internalState.metadata; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "dirty", {
        get: function () {
            if (this.internalState.fields.size > 0 && this.fields.size > 0) {
                return true;
            }
            return this.fields.size > 0 || this.internalState.displayName !== this.displayName || this.internalState.description !== this.description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "valid", {
        get: function () {
            for (var _i = 0, _a = Array.from(this.fields.values()); _i < _a.length; _i++) {
                var field = _a[_i];
                if (field.displayName == null || field.displayName.trim().length === 0) {
                    return false;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "isDirty", {
        get: function () {
            if (this.internalState.fields.size > 0 && this.fields.size > 0) {
                return true;
            }
            return this.fields.size > 0 || this.properties.size > 0;
        },
        enumerable: false,
        configurable: true
    });
    FormModelEditState.prototype.reset = function () {
        this.fields.clear();
        this.properties.clear();
    };
    Object.defineProperty(FormModelEditState.prototype, "displayName", {
        get: function () {
            return this.getProperty('displayName');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelEditState.prototype, "description", {
        get: function () {
            return this.getProperty('description');
        },
        enumerable: false,
        configurable: true
    });
    FormModelEditState.prototype.setDisplayName = function (displayName) {
        this.setProperty('displayName', displayName);
    };
    FormModelEditState.prototype.setDescription = function (description) {
        this.setProperty('description', description);
    };
    FormModelEditState.prototype.getProperty = function (propertyName) {
        if (this.properties.has(propertyName)) {
            return this.properties.get(propertyName);
        }
        return this.internalState[propertyName];
    };
    FormModelEditState.prototype.setProperty = function (propertyName, value) {
        var internalValue = this.internalState[propertyName];
        if (JSON.stringify(value) === JSON.stringify(internalValue)) {
            this.properties.delete(propertyName);
        }
        else {
            this.properties.set(propertyName, value);
        }
    };
    FormModelEditState.prototype.getFieldValue = function (fieldId) {
        if (this.fields.has(fieldId)) {
            return this.fields.get(fieldId);
        }
        return this.internalState.getFieldValue(fieldId);
    };
    FormModelEditState.prototype.setFieldValue = function (fieldId, state) {
        var internalValue = this.internalState.getFieldValue(fieldId);
        if (JSON.stringify(state) === JSON.stringify(internalValue)) {
            this.fields.delete(fieldId);
        }
        else {
            this.fields.set(fieldId, state);
        }
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], FormModelEditState.prototype, "dirty", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FormModelEditState.prototype, "valid", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FormModelEditState.prototype, "isDirty", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormModelEditState.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormModelEditState.prototype, "setDisplayName", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormModelEditState.prototype, "setDescription", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormModelEditState.prototype, "setProperty", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormModelEditState.prototype, "setFieldValue", null);
    return FormModelEditState;
}(core_shared_1.FormModelState));
exports.FormModelEditState = FormModelEditState;
//# sourceMappingURL=form.edit.model.js.map